export const TEST_ID = 'miniSeverityIcon';
